import { LazyLoadComponent, LazyLoadImage } from 'react-lazy-load-image-component';
import { hostUrlConverter, imgUrlConverter } from '../../../../util';

export const AdsBannerCardImage = ({
    productName,
    productURL,
    productImageURL,
    contentType,
    desktopImageUrl,
    mobileImageUrl,
    scrollPosition,
    googleAnalytics
}) => {
    const desktopImageUrlFinal = imgUrlConverter(desktopImageUrl ? desktopImageUrl : productImageURL)
    const mobileImageUrlFinal = imgUrlConverter(mobileImageUrl ? mobileImageUrl : productImageURL)

    return (
        <a role="button" href={hostUrlConverter(productURL)}
            className="jos-ga-tracking-element"
            data-jos-ga-tracking={JSON.stringify({
                _resolveFields: {
                    businessUnit: { 
                        catalogOsr: googleAnalytics?.catalogOSR
                    },
                    productLine: { 
                        catalogOsr: googleAnalytics?.catalogOSR 
                    }
                },
                clickText: productName, 
                modalType: '', 
                itemName: productName,
                actionType: 'button_click', 
                categoryName: '',
                contentType,
                contentName: productName
            })}
        >
            <div className="img-wrapper">
                <LazyLoadComponent>
                    <picture>
                        <source media="(min-width: 1024px)" srcSet={desktopImageUrlFinal} />
                        <LazyLoadImage src={mobileImageUrlFinal} alt={productName} scrollPosition={scrollPosition} />
                    </picture>
                </LazyLoadComponent>
            </div>
        </a>
    )
}